import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import ExampleComponent from '../ExampleComponent'
import { GlobalVariables } from 'Globals/GlobalVariables'

const dot_size = 12
const dot_color = 'var(--text-color)'
const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  if (!properties) properties = {}
  let maximum = isNaN(Number(properties.maximum))
    ? undefined
    : Number(properties.maximum)

  const propsToExlude = ['maximum']
  const propsToShow = Object.entries(properties).filter(
    (f) => !propsToExlude.includes(f[0])
  )
  if (propsToShow.length === 0) return null
  console.log('properties', Object.entries(properties), maximum)
  return (
    <AppContainer $colorMode={colorMode}>
      <TextWidth>
        <DotRating
          maximum={maximum}
          entries={propsToShow
            .filter((f) => !propsToExlude.includes(f[0]))
            .map(([label, value]) => {
              const labelandsort = label.split('#')
              const sort = +labelandsort[1] || 0
              return { label: labelandsort[0], value: Number(value), sort }
            }).sort((a,b) => a.sort - b.sort)}
        />
      </TextWidth>
    </AppContainer>
  )
}

const DotRating = ({
  maximum,
  entries,
}: {
  maximum?: number
  entries: { label: string; value: number }[]
}) => {

  return (
    <DotRatingRoot>
      {entries.map(({ label, value }, i) => {
        return (
          <DotRow
            key={'dot_row' + label + '_' + i}
            label={label}
            value={value}
            maximum={maximum}
          />
        )
      })}
    </DotRatingRoot>
  )
}

const DotRatingRoot = styled.div`
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 60px;
`

const DotRow = ({
  label,
  value,
  maximum,
}: {
  label: string
  value: number
  maximum?: number
}) => {
  let data = [...Array(value)]
  if (maximum) {
    data = [...Array(maximum)]
  }
  return (
    <DotRowRoot>
      <LabelContainer>{label}</LabelContainer>
      <DotContainer>
        {data.map((m, i) => {
          return (
            <Dot
              key={'dot-' + label + '_' + i}
              style={{
                backgroundColor:
                  i < value
                    ? 'var(--dot-filled-color)'
                    : 'var(--dot-unfilled-color)',
              }}
            />
          )
        })}
      </DotContainer>
    </DotRowRoot>
  )
}

const DotRowRoot = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:not(:last-of-type) {
    border-bottom: 1px solid var(--dot-line-color);
  }
`
const LabelContainer = styled.div`
  font-size: 18px;
`
const DotContainer = styled.div`
  display: flex;
`
const Dot = styled.div`
  margin-left: 0.5rem;
  width: ${dot_size}px;
  height: ${dot_size}px;
  border-radius: 50%;
  background-color: ${dot_color};
`
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
